export default __webpack_public_path__ + "static/media/filter-2.48219299.png";